import { WEB } from '../types';
export default {
  type: WEB,
  service: 'node1.webchain.network',
  url: 'https://node1.webchain.network',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
